import type { AppListenerMiddleware, RootState } from "@src/store/rootState";
import { initSideNavCollapsed } from "@src/store/slices/appSettings";
import { getIsAiChatOpen, isDialogOpen } from "@src/store/slices/global";

const isVivOpen = isDialogOpen("experienceBuilder");

const isAnyChatOpen = (state: RootState) =>
  getIsAiChatOpen(state) || isVivOpen(state);

/**
 * Collapses the app nav drawer whenever an AI chat surface opens — the
 * experience-creation/ui-actions/analytics panel (`global.aiChat.open`) or
 * the Viv visual builder dialog. Both chats need the width back. The drawer's
 * pre-chat state is captured on open and restored when the last chat surface
 * closes, so a merchant who had it expanded gets it back — and one who had
 * collapsed it themselves keeps it collapsed.
 */
export function setupNavigationListener(middleware: AppListenerMiddleware) {
  let collapsedBeforeChat: boolean | null = null;

  middleware.startListening({
    predicate: (_action, state: RootState, prev: RootState) =>
      isAnyChatOpen(state) && !isAnyChatOpen(prev),
    effect: (_action, api) => {
      collapsedBeforeChat = api.getState().appSettings.sideNavCollapsed;
      api.dispatch(initSideNavCollapsed(true));
    },
  });

  middleware.startListening({
    predicate: (_action, state: RootState, prev: RootState) =>
      !isAnyChatOpen(state) && isAnyChatOpen(prev),
    effect: (_action, api) => {
      if (collapsedBeforeChat === null) {
        return;
      }
      api.dispatch(initSideNavCollapsed(collapsedBeforeChat));
      collapsedBeforeChat = null;
    },
  });
}
